import type { IconData } from '@stacksjs/iconify-core'

export const file: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M347 240q-9 0-16-7t-7-16V8l232 232zm-69-23q0 29 20 49t49 20h209v440q0 10-6 17t-17 7H23q-10 0-16-7t-7-17V31q0-9 7-16t16-7h255z\"/>",
  "width": 560,
  "height": 850,
  "viewBox": "0 0 560 850"
}

export default file
